"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pipe = void 0;
var applyTo_1 = require("./applyTo");
/**
 *
 * Pipe takes HOCs and returns a function that combines them, from the left to the right
 *
 * @category Function
 * @param {...Function} functions - the functions to compose
 * @returns {Function} the composed function
 *
 * @example
 * const increment = x => 1
 * const double = x => x * 2
 * const incrementAndDouble = pipe(increment, double)
 * incrementAndDouble(1) //=> 4
 */
var pipe = function () {
    var functions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        functions[_i] = arguments[_i];
    }
    return function (value) {
        return functions.reduce(applyTo_1.applyTo, value);
    };
};
exports.pipe = pipe;
